"use strict";
var ElementSchemaRegistry = (function () {
    function ElementSchemaRegistry() {
    }
    return ElementSchemaRegistry;
}());
exports.ElementSchemaRegistry = ElementSchemaRegistry;
//# sourceMappingURL=element_schema_registry.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/compiler/src/schema/element_schema_registry.js
 ** module id = 5
 ** module chunks = 2
 **/